'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';
import { FiDownload } from 'react-icons/fi';

export function ProductAttachments({ product }: { product: ProductDetailData }) {
  const { t } = useTranslations();
  return (
    <section className={cn('custom-section', 'py-8 sm:py-10 lg:py-12')}>
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start gap-4 sm:gap-5 lg:gap-6',
        )}
      >
        <h2 className="text-lg font-semibold text-foreground sm:text-xl lg:text-2xl">
          {t('text333')}
        </h2>
        {product.attachments && product.attachments.length !== 0 ? (
          <div className="grid w-full grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2 lg:gap-6">
            {product.attachments?.map(attachment => (
              <div
                key={attachment.name}
                className="col-span-1 flex w-full flex-col items-center justify-between gap-4 rounded-[6px] bg-[#F4F5FB] px-4 py-3 sm:flex-row sm:px-5 lg:px-6"
              >
                <div className="flex items-center justify-start gap-2">
                  <Image
                    src={'/images/icons/pdf.svg'}
                    alt="PDF"
                    width={0}
                    height={0}
                    className="h-6 w-auto shrink-0 object-contain"
                  />
                  <p className="line-clamp-1 overflow-ellipsis text-sm font-light text-foreground">
                    {attachment.name}
                  </p>
                </div>
                <Link
                  prefetch={false}
                  href={attachment.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 text-sm font-normal text-primary transition-all hover:opacity-80"
                >
                  <FiDownload size={20} /> Stiahnuť
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <p className="w-full py-6 text-center text-base font-normal text-foreground sm:text-lg lg:text-xl">
            {t('text3510')}
          </p>
        )}
      </div>
    </section>
  );
}
